import { atom } from '@reatom/framework'

import {
  userPremiumsModelAtom,
  userPremiumTabAtom,
} from '@root/features/premium'

export const premiumCurrenciesStateAtom = atom((ctx) => {
  const model = ctx.spy(userPremiumsModelAtom)
  const tab = ctx.spy(userPremiumTabAtom)

  if (tab === 'active') {
    return ctx.spy(model.activePremiums)
  }

  return ctx.spy(model.expiredPremiums)
}, 'premiumCurrenciesStateAtom')
